var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.2.5C33.8.5.3,34,.3,75.3s33.5,74.8,74.8,74.8,74.8-33.5,74.8-74.8S116.5.5,75.2.5ZM76.1,136.8c-34,0-61.5-27.5-61.5-61.5S42.1,13.8,76.1,13.8s61.5,27.5,61.5,61.5-27.5,61.5-61.5,61.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.6,105.2v1.4c0,.5-.1,1-.3,1.5.2-.9.3-1.9.3-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.7,58.4v15.8c0,2.6-1.5,5.1-4,6-1,.4-1.6.3-2.1,0-1.7-.8-1-3.7-3.2-6.5-1.4-1.8-3.1-2.5-5.1-3.4-5.5-2.3-10.4-4.2-14.7-5.8v40.5c0,1-.1,2-.3,2.9-1.5,7.2-8.6,12.7-17.2,12.7s-17.5-7-17.5-15.6,7.8-15.6,17.5-15.6,6.9,1,9.7,2.6V31.5c0-2.1,1.7-3.7,3.7-3.7h.4c2,0,3.7,1.7,3.7,3.7v5.3c4.5,3.6,8.5,5.7,11.5,6.9,5.3,2.2,9.9,2.8,14.2,7.1.3.3.6.6.9.9,1.6,1.9,2.5,4.2,2.5,6.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMusicIcon);
export default __webpack_public_path__ + "static/media/play_music_icon.f4e3cbad999106552f335dc97e5cf362.svg";
export { ForwardRef as ReactComponent };